import {FuturesSDK, ExchangeSDK} from '@binance/js-sdk'
import {API_HOST} from 'constants'

export const MainSDK = new ExchangeSDK()

const setConfig = !__DEV__
  && API_HOST && {
  baseUrl: API_HOST
}
export const SpeedApiSdk = new FuturesSDK(setConfig)

const ApiSdk = new FuturesSDK()

export default ApiSdk
